import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: '首页', href: '/' },
    ...categories.slice(0, 5).map((c) => ({ label: c.name, href: `/category/${c.slug}` })),
    { label: '关于我们', href: '/about' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="container-custom flex items-center justify-between h-16 md:h-20">
        <Link to="/" className="flex items-center gap-2 group">
          <span className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-sm md:text-base">
            51
          </span>
          <span className={`font-heading font-bold text-lg md:text-xl transition-colors ${
            scrolled ? 'text-foreground-950' : 'text-background-50'
          }`}>
            吃瓜
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`px-3 lg:px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                scrolled
                  ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                  : 'text-background-100 hover:text-background-50 hover:bg-white/10'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="hidden md:block">
          <Link
            to="/category/jinri-dagua"
            className={`px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
              scrolled
                ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                : 'bg-white/20 text-background-50 hover:bg-white/30 backdrop-blur-sm'
            }`}
          >
            今日大瓜
          </Link>
        </div>

        <button
          type="button"
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
            scrolled ? 'text-foreground-950' : 'text-background-50'
          }`}
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="切换导航菜单"
        >
          <i className={mobileMenuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
        </button>
      </nav>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-lg border-t border-background-200">
          <div className="container-custom py-4 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className="px-4 py-3 rounded-lg text-foreground-700 hover:text-primary-600 hover:bg-primary-50 text-sm font-medium"
                onClick={() => setMobileMenuOpen(false)}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}